import { Injectable, inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ImpersonatedHttpClient } from '@ceres/shared/services';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
    GenerateReleaseNoteRequest,
    ReleaseNote,
    ReleaseNotesPage,
    ReleaseNotesQuery
} from '../interfaces/release-note.interface';

@Injectable({ providedIn: 'root' })
export class ReleaseNotesService {
    private readonly http = inject(ImpersonatedHttpClient);
    private readonly endpoint = `${environment.edgeService}/release-notes`;

    public findAll(): Observable<ReleaseNote[]> {
        return this.http.get<ReleaseNote[]>(this.endpoint);
    }
    public findPage(query: ReleaseNotesQuery): Observable<ReleaseNotesPage> {
        let params = new HttpParams();
        Object.entries(query).forEach(([key, value]) => {
            if (value !== undefined) params = params.set(key, String(value));
        });
        return this.http.get<ReleaseNotesPage>(`${this.endpoint}/page`, { params });
    }
    public getRecent(): Observable<ReleaseNote | null> {
        return this.http.get<ReleaseNote | null>(`${this.endpoint}/recent`);
    }
    public getAllForAdmin(): Observable<ReleaseNote[]> {
        return this.http.get<ReleaseNote[]>(`${this.endpoint}/admin`);
    }
    public create(note: Partial<ReleaseNote>): Observable<ReleaseNote> {
        return this.http.post<ReleaseNote>(this.endpoint, note);
    }
    public generate(request: GenerateReleaseNoteRequest): Observable<ReleaseNote> {
        return this.http.post<ReleaseNote>(`${this.endpoint}/generate`, request);
    }
    public regenerate(id: number): Observable<ReleaseNote> {
        return this.http.post<ReleaseNote>(`${this.endpoint}/${id}/regenerate`, {});
    }
    public update(id: number, note: Partial<ReleaseNote>): Observable<ReleaseNote> {
        return this.http.patch<ReleaseNote>(`${this.endpoint}/${id}`, note);
    }
    public publish(id: number): Observable<ReleaseNote> {
        return this.http.patch<ReleaseNote>(`${this.endpoint}/${id}/publish`, {});
    }
    public unpublish(id: number): Observable<ReleaseNote> {
        return this.http.patch<ReleaseNote>(`${this.endpoint}/${id}/unpublish`, {});
    }
    public remove(id: number): Observable<void> {
        return this.http.delete<void>(`${this.endpoint}/${id}`);
    }
}
